<h2>{{slide.question}}</h2>
<ui-select [items]="slide.answers" (valueChange)="selectAnswer.next($event)">
</ui-select>